<div class="building-fundamental">
    <div class="row">
        <!-- building -->
        <div class="col-md-6 left">
            <div class="building">
                <h3 class="title mb-0 d-md-block d-none">{{ dataFundamental[0]?.title }}</h3>
                <div class="picture-1 my-md-4">
                    <img class="w-100" [src]="apiAsset + dataFundamental[0]?.picture" alt="">
                </div>
                <h3 class="title pr-5 d-md-none my-4 d-block mb-0">{{ dataFundamental[0]?.title }}</h3>
                <div class="detail" [innerHTML]="dataFundamental[0]?.content"></div>
            </div>
        </div>
        <!-- fundamental -->
        <div class="col-md-6 d-md-block d-none pt-3 right">
            <div class="fundamental">
                <div class="detail" [innerHTML]="dataFundamental[1]?.content"></div>
                <div class="row mt-xl-4 mt-md-3">
                    <div class="col-xl-6 pt-xl-1">
                        <h6 class="sub-tit1 d-xl-none d-md-block mb-md-4">{{ dataFundamental[1]?.title }}</h6>
                        <div class="picture-2">
                            <img class="w-100" [src]="apiAsset + dataFundamental[1]?.picture" alt="">
                        </div>  
                        <h6 class="sub-tit1 d-xl-block d-md-none">{{ dataFundamental[1]?.title }}</h6>
                    </div>
                    <div class="col-xl-6 mt-xl-0 mt-md-3">
                        <h6>{{ dataFundamental[2]?.title }}</h6>
                        <div class="detail" [innerHTML]="dataFundamental[2]?.content"></div>
                    </div>
                </div>
                <!-- <div class="picture-3 d-xl-block d-md-none">
                    <img class="w-100" [src]="apiAsset + dataFundamental[2]?.picture" alt="">
                </div> -->
            </div>
        </div>
    </div>    
</div>
